
import React from 'react';

function ScrollingTicker() {
  return (
    <div className="our-scrolling-ticker">
      <div className="scrolling-ticker-box">
        <div className="scrolling-content">
          <span><img src="/hellotruck-web-images/icon-asterisk.svg" alt="" />100% trusted transportation</span>
          <span><img src="/hellotruck-web-images/icon-asterisk.svg" alt="" />100% trusted transportation</span>
        </div>

        <div className="scrolling-content">
          <span><img src="/hellotruck-web-images/icon-asterisk.svg" alt="" />100% trusted transportation</span>
          <span><img src="/hellotruck-web-images/icon-asterisk.svg" alt="" />100% trusted transportation</span>
        </div>
      </div>
    </div>
  );
}

export default ScrollingTicker;
